import { useState } from "react"

export interface DialogStateProps {
  open: boolean
  toggle: () => void
}

const useDialog = (): DialogStateProps => {
  const [open, setOpen] = useState(false)

  const toggle = () => {
    setOpen((prev) => !prev)
  }

  return {
    open,
    toggle,
  }
}

export default useDialog
